import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { ToastrService } from 'ngx-toastr';
import { AddVesselDialogComponent } from '../add-vessel-dialog/add-vessel-dialog.component';
import { VesselData } from '../vessel-reg/vessel-data.model';
import { LocalStorageService } from './local-storage.service';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import { AddSpeciesDialogComponent } from '../add-species-dialog/add-species-dialog.component';
import { LookupItem } from './lookup-item.model';


@Injectable({
  providedIn: 'root'
})
export class CommonFunctionService {

  constructor(private dialog: MatDialog,
     private toastr: ToastrService,
      private onlineStatus: OnlineStatusService,
       private auth: AuthService,
        public router: Router) { }


  
  /*
    Vessel functionality, adding and checking if valid
  */


  addVessel(index: number, isEdit: boolean, isMothership: boolean = false): Promise<VesselData> {

    return new Promise<VesselData>((res, rej) => {

      const dialogRef = this.dialog.open(AddVesselDialogComponent, {
        width: '425px',
        data: {
          vessel: index != -1 ? LocalStorageService.current_user.operatedVessels[index] : null,
          edit: isEdit
        }

      });
  
      dialogRef.afterClosed().subscribe(result => {
        console.log(result);
        if (result) {
          if (result != 'delete') {
            
            let newVessel = new VesselData(result.vesselName, result.vesselNumber);
  
            if (this.onlineStatus.getStatus() === OnlineStatusType.OFFLINE) {
              newVessel.isRecognized = false;
              if (index == -1) LocalStorageService.current_user.operatedVessels.push(newVessel);
              else LocalStorageService.current_user.operatedVessels[index] = newVessel;
              
              LocalStorageService.updateUserVessels(LocalStorageService.current_user.userName, LocalStorageService.current_user.operatedVessels).then(_ => {
                console.log("User vessels updated to "); 
                console.log(LocalStorageService.current_user.operatedVessels);
              });           
              this.toastr.warning('Vessel ' + newVessel + ' cannot be verified while offline', 'Unrecognized vessel');
              res(newVessel);
              return;
            }
  
            if (this.auth.checkAccessToken().expired) {
              console.log("Access token expired, refreshing..");
              if (this.auth.checkRefreshToken().expired) {
                //Go to menu screen
                this.toastr.warning('Login to add and view your vessels' ,'Sign-up session expired');
                this.router.navigate(['menu']);
                rej('Refresh token expired');
              } else {
                this.auth.postRefreshToken().subscribe((token: any) => {
                  LocalStorageService.current_user.accessToken = token.accessToken;
                  LocalStorageService.current_user.refreshToken = token.refreshToken;
                  LocalStorageService.accessToken = token.accessToken;
                  LocalStorageService.updateUser(false, true).then(() => {
                    this.postVesselSearch(result.vesselNumber, newVessel, index);
                    res(newVessel);
                    return;
                  });
                })                         
              }
            } else {
              //Post updated vessel search instead of vessel search
              this.postVesselSearch(result.vesselNumber, newVessel, index);
              res(newVessel); 
              return;            
            }          
          } else if (index != -1) {
            let vesselName = LocalStorageService.current_user.operatedVessels.splice(index, 1)[0];
            if (LocalStorageService.user_trip.groundfishDelivery.vessel == vesselName) {
              LocalStorageService.user_trip.groundfishDelivery.vessel = new VesselData('', '');
            }
            LocalStorageService.updateUser(true, false).then(() => {
              this.toastr.success('Vessel list updated', 'Success');
            });
          }
        }     
      });
    })
  }

  /**
   * Valid vessel?
   * @param vesselNum 
   * @param newVessel 
   */
  postVesselSearch(vesselNum: any, newVessel: VesselData, index: number) {
    if (index != -1) LocalStorageService.current_user.operatedVessels[index] = newVessel;
    this.auth.postVesselSearch(vesselNum).subscribe((list: any[]) => {
      if (index != -1) LocalStorageService.current_user.operatedVessels[index].isRecognized = (list.length > 0);
      else {
        newVessel.isRecognized = (list.length > 0);
        LocalStorageService.current_user.operatedVessels.push(newVessel);
      } 

      LocalStorageService.updateUserVessels(LocalStorageService.current_user.userName, LocalStorageService.current_user.operatedVessels).then(_ => {
        console.log("User vessels updated to "); 
        console.log(LocalStorageService.current_user.operatedVessels);
      });
      if (list.length > 0) this.toastr.success('Recognized vessel added.', 'Success');
      else this.toastr.warning('Vessel ' + newVessel + ' is not recognized by its number. Review for typos', 'Unrecognized vessel');
    }, _ => {
      if (index != -1) LocalStorageService.current_user.operatedVessels[index].isRecognized = false;
      else {
        newVessel.isRecognized = false;
        LocalStorageService.current_user.operatedVessels.push(newVessel);
      } 
      LocalStorageService.updateUserVessels(LocalStorageService.current_user.userName, LocalStorageService.current_user.operatedVessels)
    })
  }


  addSpecies(index: number, filterOption: 'Combined' | 'HMS' | 'Groundfish' | 'Trawl'): Promise<boolean> {

    return new Promise<boolean>((res, rej) => {
      this.dialog.open(AddSpeciesDialogComponent, {
        width: '425px',
        data: {
          species: index === -1 ? null : LocalStorageService.current_user.favoriteSpecies[index],
          filterOption: filterOption
        }
      }).afterClosed().subscribe((result: any) => {
  
        console.log(result);
  
        if (result) {
  
          // if species added successfully (deleting a new species does nothing)
          if (result != 'delete') {
            if (this.onlineStatus.getStatus() === OnlineStatusType.OFFLINE) {
              this.updateSpecies(result.species, index);       
              this.toastr.success('Species ' + result.species.name + ' has been added offline.', 'Offline');
              res(true);
              return;
            }
  
            if (this.auth.checkAccessToken().expired) {
              console.log("Access token expired, refreshing...");
  
              if (this.auth.checkRefreshToken().expired) {
                // Go to menu screen
                this.toastr.warning('Login to add and view your favorite species.', 'Sign-up session expired');
                this.router.navigate(['menu']);
                res(false);
                return;
              } else {
                this.auth.postRefreshToken().subscribe((token: any) => {
                  LocalStorageService.current_user.accessToken = token.accessToken;
                  LocalStorageService.current_user.refreshToken = token.refreshToken;
                  LocalStorageService.updateUser(false, true).then(() => {
                    this.updateSpecies(result.species, index);
                    this.toastr.success("Species " + result.species.name + " added.", "Add Success");
                    res(true);
                    return;
                  });
                });
              }
            } else {
              this.updateSpecies(result.species, index);
              this.toastr.success("Species " + result.species.name + " added.", "Add Success");
              res(true);
            }
          } else if (index != -1) {
            LocalStorageService.current_user.favoriteSpecies.splice(index, 1);
            LocalStorageService.updateUserSpecies(LocalStorageService.current_user.favoriteSpecies).then(() => {
              console.log("User favorite species updated to:");
              console.log(LocalStorageService.current_user.favoriteSpecies);
              res(true);
              return;
            });
          } else {
            res(false);
            return;
          }
        } else {
          res(false);
        }
      });
    })   
  }



  updateSpecies(species: LookupItem, editIndex: number) {
    if (editIndex != -1) LocalStorageService.current_user.favoriteSpecies[editIndex] = species;
    else LocalStorageService.current_user.favoriteSpecies.push(species);
    LocalStorageService.updateUserSpecies(LocalStorageService.current_user.favoriteSpecies).then(() => {
      console.log("User favorite species updated to:");
      console.log(LocalStorageService.current_user.favoriteSpecies);
    });
  }

}
